import { render, staticRenderFns } from "./index.backup.vue?vue&type=template&id=54c9bd3c&scoped=true&"
import script from "./index.backup.vue?vue&type=script&lang=js&"
export * from "./index.backup.vue?vue&type=script&lang=js&"
import style0 from "./index.backup.vue?vue&type=style&index=0&id=54c9bd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9bd3c",
  null
  
)

export default component.exports